import {
  LoginFormSection,
  HeadlineTicker,
} from "../components";
import { Link } from "react-router-dom";
import usePageMeta from "../hooks/usePageMeta";

export default function Login() {
  usePageMeta({
    title: "Sign In · RepCheck",
    description:
      "Sign in to your RepCheck account to monitor social media reputation risks in real time.",
  });
  return (
    <div className="min-h-screen w-full bg-card flex flex-col">
      {/* Top bar */}
      <div className="flex justify-between items-center px-6 sm:px-10 pt-6 pb-2">
        <span className="flex items-center text-[2rem] font-bold font-roboto">
          <img src="/favicon.svg" alt="RepCheck logo" width="32" height="32" className="h-8 w-8 mr-2" />
          RepCheck
        </span>
        {/* Link to Sign-up page */}
        <span className="text-lg font-semibold font-roboto">
          <Link to="/register" className="text-brand-600 hover:text-brand-700">Apply for access</Link>
        </span>
      </div>
      {/* Main Content */}
      <div className="flex-1 flex flex-col items-center justify-center px-4">
        <div className="bg-card border border-border rounded-2xl shadow-card-hover px-6 sm:px-10 py-12 flex flex-col items-center max-w-md w-full">
          <h1 className="text-3xl font-semibold text-foreground text-center mb-1">
            Welcome back
          </h1>
          <p className="text-base text-muted-foreground text-center mb-6">
            Sign in to your RepCheck account
          </p>
          <LoginFormSection />
          <div className="my-4 w-full flex flex-col items-center">
            <div className="flex items-center justify-center text-base mt-6">
              <span className="text-muted-foreground">
                Not in the pilot yet?{" "}
              </span>
              <span className="ml-1 font-medium">
                <Link to="/register" className="text-brand-600 hover:text-brand-700">Apply for access</Link>
              </span>
            </div>
          </div>
        </div>
      </div>
      {/* Bottom Banner */}
      <div className="w-full">
        <HeadlineTicker />
      </div>
    </div>
  );
}
